module.exports = (str) => {
  if (!str.replace(/\s/g, '').length) {
    return true;
  }
  return false;
};
